export default __webpack_public_path__ + "static/media/wotfard-thin-webfont.74e53d13.woff2";